/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_TitleInputs */

const en_dropbox_title = /** @type {(inputs: Dropbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox`)
};

const es_dropbox_title = /** @type {(inputs: Dropbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox`)
};

/**
* | output |
* | --- |
* | "Dropbox" |
*
* @param {Dropbox_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_title = /** @type {((inputs?: Dropbox_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_title(inputs)
	return en_dropbox_title(inputs)
});